import axios from "axios";
const config = require(`../../environment/development`).config;
let cancelTokenQuote;
let cancelTokenOrder;

export const sendOrderCreationMailToAdmin = async (token, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-type": "application/json",
      };

      let response = await axios.post(
        `${config.backEnd}/mail/order-creation-to-admin`,
        data,
        { headers: header }
      );
      return resolve(response.data);
    } catch (error) {
      return reject(error);
    }
  });
};

export const fetchQuotesForParameters = async (token, data, isCancellable) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (typeof cancelTokenQuote != typeof undefined && isCancellable) {
        cancelTokenQuote.cancel();
      }

      let headers = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-type": "application/json",
      };

      cancelTokenQuote = axios.CancelToken.source();

      const response = await axios.get(
        `${config.backEnd}/fetch-quote-for-parameters`,
        {
          cancelTokenQuote: cancelTokenQuote.token,
          headers,
          params: data,
        }
      );

      return resolve(response.data);
    } catch (error) {
      return reject(error);
    }
  });
};

export const fetchOrdersForParameters = async (token, data, isCancellable) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (typeof cancelTokenOrder != typeof undefined && isCancellable) {
        cancelTokenOrder.cancel();
      }

      let headers = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-type": "application/json",
      };

      cancelTokenOrder = axios.CancelToken.source();
      
      const response = await axios.get(
        `${config.backEnd}/fetch-orders-for-parameters`,
        {
          cancelTokenOrder: cancelTokenOrder.token,
          headers,
          params: data,
        }
      );

      return resolve(response.data);
    } catch (error) {
      return reject(error);
    }
  });
};
